// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3bGK8","actions":"GroupTable_actions__1IHZa","deleteModalFooter":"GroupTable_deleteModalFooter__Y7aOD"};